import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 查询lcrm商机列表
export const opportunityInfoPageApi = (data) => {
    return request({
        url: apiCrmHost + '/opportunity/info/page',
        method: 'post',
        data
    });
};
// 查询IT资源对接申请详情
export const queryResourceApplication = (data) => {
    return request({
        url: apiCrmHost + '/neoCrm/resourceApplication/query',
        method: 'post',
        data
    });
};
// 商机导出权限控制
export const queryOpportunityRelation = (data) => {
    return request({
        url: apiCrmHost + '/opportunity/info/report/auth',
        method: 'post',
        data
    });
};
// 商机转移-wy
export const saveOpportunityTransfer = (data) => {
    return request({
        url: apiCrmHost + '/opportunity/opportunityTransfer',
        method: 'post',
        data
    });
};
// 商机-导出-wy
export const opportunityListExport = (data) => {
    return request({
        url: apiCrmHost + '/opportunity/export',
        method: 'post',
        data
    });
};
